import { Card } from 'antd';
import * as React from 'react';
import ReportForm from 'src/components/Reporting/ReportForm';

class Dashboard extends React.Component {
  public render() {
    return (
      <div style={{ display: 'inline-block' }}>
        <Card title='Finance Report'>
          <ReportForm />
        </Card>
      </div>
    );
  }
}

export default Dashboard;
